import { CommonModule } from '@angular/common';
import { Component, signal } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ModalController, NavParams } from '@ionic/angular/standalone';
import { AppCommonModule } from 'src/app/common.module';
import { MainDialogComponent } from 'src/app/components/main-dialog/main-dialog.component';

@Component({
  selector: 'app-add-area-dialog',
  templateUrl: './add-area.dialog.html',
  styleUrls: ['./add-area.dialog.scss'],
  imports: [
    AppCommonModule,
    CommonModule,
    MainDialogComponent,
  ],
})
export class AddAreaDialogComponent {
  formGroup: FormGroup;

  isCommon = signal(false);
  hasEdit = signal(false);
  typeS = signal<'residence' | 'common' | 'commercial'>(null);

  constructor(
    private formBuilder: FormBuilder,
    private _modal: ModalController,
    private navParams: NavParams,
  ) {
    this.typeS.set(this.navParams.get('type'));
    this.isCommon.set(this.typeS() === 'common');

    this.formGroup = this.formBuilder.group({
      name: [''],
      areas: this.formBuilder.array([]),
    });

    this.addItem();
  }

  getFields() {
    return this.formGroup.get('areas') as FormArray;
  }

  addItem() {
    const item = this.formBuilder.group({
      name: ['', Validators.required],
      floor: [this.navParams.get<string>('floor') ?? null],
      type: [this.typeS()],
    });
    this.getFields().push(item);
  }

  deleteItem(index: number) {
    this.getFields().removeAt(index);
  }

  save() {
    const item = this.formGroup.value;
    this._modal.dismiss({ areas: item.areas.filter((it: { name: string; type: 'residence' | 'common' | 'commercial' }) => it.name.length > 0), name: item.name });
  }

  dismiss() {
    this._modal.dismiss();
  }
}
